<div
  class="opener opened"
  (click)="toggleSlide()"
  [ngClass]="{ open: !isSlideShown }"
>
  <span class="name">{{ filter.name() | translate }}</span>
  <span class="filter">{{ selectedLabels }}</span>
</div>
<div class="slider" [hidden]="isSlideShown">
  <div class="slider-container">
    <ul>
      <li>
        <label class="slider-control">
          <input
            class="check-all x_checkbox x_sm"
            type="checkbox"
            [formControl]="checkBoxAll"
            (change)="selectAll($event.target.checked)"
          />
          <div class="x_checkbox-label">
            {{ I18n.CommonStrings.All | translate }}
          </div>
        </label>

        <ul>
          @for (
            filter of filter.items;
            track trackByFilterItem($index, filter)
          ) {
            @if (!filter?.items) {
              <li>
                <label class="slider-control">
                  <input
                    class="x_checkbox x_sm"
                    type="checkbox"
                    [formControl]="formCategory.controls[filter.id]"
                  />
                  <div class="x_checkbox-label">
                    {{ filter.name() | translate }}
                  </div>
                </label>
              </li>
            } @else {
              <li class="slider-child-group">
                <label>
                  <input
                    class="check-all x_checkbox x_sm"
                    type="checkbox"
                    [formControl]="formCategory.controls[filter.id]"
                    (change)="
                      selectAllChildren($event.target.checked, filter.id)
                    "
                  />
                </label>
                <label
                  class="opener opened slider-control"
                  (click)="toggleChildSlide($event.target)"
                  [ngClass]="{ open: !isChildSlideShown }"
                >
                  {{ filter.name() | translate }}
                </label>
                <div class="slider" [hidden]="isChildSlideShown">
                  <ul>
                    @for (
                      child of filter.items;
                      track trackByFilterItem($index, child)
                    ) {
                      <li>
                        <label
                          class="slider-control"
                          [attr.e2e-attr]="E2E_ATTRIBUTES.CHECKBOX_CONTROL"
                        >
                          <input
                            class="x_checkbox x_sm"
                            type="checkbox"
                            [formControl]="formCategory.controls[child.id]"
                          />
                          <div class="x_checkbox-label">
                            {{ child.name() | translate }}
                          </div>
                        </label>
                      </li>
                    }
                  </ul>
                </div>
              </li>
            }
          }
        </ul>
      </li>
    </ul>
  </div>
</div>
